import { MessageCircle, CalendarCheck, Eye } from "lucide-react";
import { waLink, WA_MESSAGES } from "@/lib/business";
import { WhatsAppIcon } from "./WhatsAppIcon";

const STEPS = [
  {
    icon: MessageCircle,
    text: "Chame a gente no WhatsApp",
  },
  {
    icon: CalendarCheck,
    text: "Consulte os horários disponíveis",
  },
  {
    icon: Eye,
    text: "Faça seu exame com um profissional parceiro",
  },
];

export const EyeExam = () => (
  <section
    id="exame"
    data-testid="exam-section"
    className="scroll-mt-24 bg-brand"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div data-reveal>
          <p
            data-testid="exam-overline"
            className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-200"
          >
            Exame de Vista
          </p>
          <h2
            data-testid="exam-heading"
            className="mt-4 font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white"
          >
            Agende seu exame de vista pelo WhatsApp
          </h2>
          <p
            data-testid="exam-text"
            className="mt-5 text-base sm:text-lg leading-relaxed text-emerald-50"
          >
            Trabalhamos com profissionais parceiros para a realização de exame
            de vista. Para consultar a disponibilidade e agendar o seu
            horário, é só mandar uma mensagem — respondemos pelo WhatsApp.
          </p>
          <a
            href={waLink(WA_MESSAGES.exam)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="exam-whatsapp-button"
            className="mt-8 inline-flex items-center justify-center gap-2 rounded-full bg-white px-7 py-3.5 text-base font-semibold text-brand shadow-md hover:bg-emerald-50 hover:shadow-lg btn-motion focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-brand"
          >
            <WhatsAppIcon className="w-5 h-5" />
            Consultar horário para exame
          </a>
        </div>

        <ol
          data-reveal
          style={{ transitionDelay: "150ms" }}
          className="space-y-4"
          data-testid="exam-steps"
        >
          {STEPS.map(({ icon: Icon, text }, index) => (
            <li
              key={text}
              data-testid={`exam-step-${index + 1}`}
              className="flex items-center gap-5 rounded-2xl bg-white/10 backdrop-blur-sm border border-white/20 p-6"
            >
              <span className="inline-flex items-center justify-center w-12 h-12 shrink-0 rounded-full bg-white text-brand font-heading text-lg font-bold">
                {index + 1}
              </span>
              <div className="flex items-center gap-3">
                <Icon className="w-5 h-5 text-emerald-200 shrink-0" />
                <p className="text-base font-medium text-white">{text}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </div>
  </section>
);
